import {warehouseStaffInitialState} from "./InitialState";
import {IActionType, IFetchStaffActionResponse} from "../../interfaces/Index";
import * as actionTypes from "../actionTypes/Index";

const initialState = { ...warehouseStaffInitialState };


export const appendUpdateStaff = (
    payload: IFetchStaffActionResponse,
    state: any
) => {
  if (payload.isPaginatedRes) {
    return [...state.staff, ...payload.staff];
  }
  return payload;
};

export default function warehouseStaffReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.WAREHOUSE_STAFF_LISTING_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false
      });
    }

    case actionTypes.WAREHOUSE_STAFF_LISTING_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isWarehouseStaffUpdated: false,
        isWarehouseStaffCreated :false,
        staff: appendUpdateStaff(action.payload as IFetchStaffActionResponse, state),
        pagination: (action.payload! as any).pagination,
      });
    }

    case actionTypes.WAREHOUSE_STAFF_LISTING_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }

    case actionTypes.CREATE_STAFF_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isWarehouseStaffCreated: false,
        isError: false,
      });
    }

    case actionTypes.CREATE_STAFF_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isWarehouseStaffCreated: true,
        isError: false
      });
    }

    case actionTypes.CREATE_STAFF_FAIL: {
      return Object.assign({}, state, {
        isError: true,
        error: action.error,
        isWarehouseStaffCreated: false,
        isLoading: false
      })
    }

    case actionTypes.GET_ALL_WAREHOUSES_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null
      });
    }

    case actionTypes.GET_ALL_WAREHOUSES_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        warehouseList: action.payload
      })
    }

    case actionTypes.GET_ALL_WAREHOUSES_FAIL: {
      return Object.assign({}, state, {
        isLoading:false,
        isError: true,
        error: action.error,
      });
    }

    case actionTypes.GET_WAREHOUSE_STAFF_USER_DETAILS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isWarehouseStaffUserDetailsFetched: false,
        warehouseStaffUserDetails: null,
        error: null,
      });
    }
    case actionTypes.GET_WAREHOUSE_STAFF_USER_DETAILS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isWarehouseStaffUserDetailsFetched: true,
        isWarehouseStaffCreated: false,
        warehouseStaffUserDetails: action.payload,
      });
    }
    case actionTypes.GET_WAREHOUSE_STAFF_USER_DETAILS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isWarehouseStaffUserDetailsFetched: false,
        error: action.error,
      });
    }

    case actionTypes.UPDATE_STAFF_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isWarehouseStaffUpdated: false,
        error: null
      });
    }

    case actionTypes.UPDATE_STAFF_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isWarehouseStaffUpdated: true,
        error: null
      });
    }

    case actionTypes.UPDATE_STAFF_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isWarehouseStaffUpdated: false,
        error: action.error
      });
    }


    case actionTypes.GET_ALL_JOB_TYPES_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null
      })
    }

    case actionTypes.GET_ALL_JOB_TYPES_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        jobTypesList: action.payload
      })
    }

    case actionTypes.GET_ALL_JOB_TYPES_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        jobTypesList: null
      })
    }


    default:
      return state;
  }
}
